export const setExpenses = (state, payload) => {
  state.expenses = payload;
};